import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { T } from "../constants";

const useStyles = makeStyles({
  wrap: { display: "flex", alignItems: "center", gap: 10 },
  note: {
    fontSize: 11,
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: T.primary,
    whiteSpace: "nowrap",
  },
  button: {
    flexShrink: 0,
    borderRadius: 999,
    padding: "6px 14px",
    fontSize: 11,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "all 0.15s ease",
    "&:disabled": { cursor: "default", opacity: 0.55 },
  },
});

/*
 * One switch for the runner looking at the screen - never a roster, and never
 * a control over anybody else. Shifts are a per-venue feature: with them off
 * there is no stint to be on, so the switch is a control over nothing.
 */
export default function ShiftToggle({
  shiftsEnabled = true,
  onShift,
  shiftWindow,
  busy,
  onToggle,
}) {
  const s = useStyles();

  if (!shiftsEnabled) return null;

  return (
    <div className={s.wrap}>
      {/* An ad-hoc stint has no posted hours, so it says only that the runner
          is on. */}
      {onShift && (
        <span className={s.note}>
          On shift{shiftWindow && `: ${shiftWindow}`}
        </span>
      )}
      <button
        type="button"
        onClick={onToggle}
        disabled={busy}
        className={s.button}
        /* Coloured for the action, not the state: going on is the inviting
           one, going off is the quiet one. */
        style={
          onShift
            ? {
                border: `1px solid ${T.border}`,
                background: T.surface,
                color: T.mutedFg,
              }
            : {
                border: `1px solid ${T.primary}`,
                background: T.primaryTint,
                color: T.primary,
              }
        }
      >
        {onShift ? "Go off shift" : "Go on shift"}
      </button>
    </div>
  );
}
